<template>
<div class="chapter">
<div class="inner_page">
<img src="03-chapter02.html.jpg" style="margin-left: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03-chapter02.vue?673b8217